export default "__VITE_ASSET__BgpjUjWP__"